export default [
    {
      path: '/apps/calendar',
      name: 'apps-calendar',
      component: () => import('@/views/apps/calendar/Calendar.vue'),
    },

    // *===============================================---*
    // *--------- EMAIL & IT'S FILTERS N LABELS -------------------------------*
    // *===============================================---*
    {
      path: '/apps/email',
      name: 'apps-email',
      component: () => import('@/views/apps/email/Email.vue'),
      meta: {
        roles:[101, 103],
        contentRenderer: 'sidebar-left',
        contentClass: 'email-application',
      },
    },
    {
      path: '/apps/email/:folder',
      name: 'apps-email-folder',
      component: () => import('@/views/apps/email/Email.vue'),
      meta: {
        contentRenderer: 'sidebar-left',
        contentClass: 'email-application',
        navActiveLink: 'apps-email',
      },
      beforeEnter(to, _, next) {
        if (['sent', 'draft', 'starred', 'spam', 'trash'].includes(to.params.folder)) next()
        else next({ name: 'error-404' })
      },
    },
    {
      path: '/apps/email/label/:label',
      name: 'apps-email-label',
      component: () => import('@/views/apps/email/Email.vue'),
      meta: {
        contentRenderer: 'sidebar-left',
        contentClass: 'email-application',
        navActiveLink: 'apps-email',
      },
      beforeEnter(to, _, next) {
        if (['personal', 'company', 'important', 'private'].includes(to.params.label)) next()
        else next({ name: 'error-404' })
      },
    },

    // *===============================================---*
    // *--------- TODO & IT'S FILTERS N TAGS ---------------------------------------*
    // *===============================================---*
    {
      path: '/apps/todo',
      name: 'apps-todo',
      component: () => import('@/views/apps/todo/Todo.vue'),
      meta: {
        contentRenderer: 'sidebar-left',
        contentClass: 'todo-application',
      },
    },
    {
      path: '/apps/todo/:filter',
      name: 'apps-todo-filter',
      component: () => import('@/views/apps/todo/Todo.vue'),
      meta: {
        contentRenderer: 'sidebar-left',
        contentClass: 'todo-application',
        navActiveLink: 'apps-todo',
      },
      beforeEnter(to, _, next) {
        if (['important', 'completed', 'deleted'].includes(to.params.filter)) next()
        else next({ name: 'error-404' })
      },
    },
    {
      path: '/apps/todo/tag/:tag',
      name: 'apps-todo-tag',
      component: () => import('@/views/apps/todo/Todo.vue'),
      meta: {
        contentRenderer: 'sidebar-left',
        contentClass: 'todo-application',
        navActiveLink: 'apps-todo',
      },
      beforeEnter(to, _, next) {
        if (['team', 'low', 'medium', 'high', 'update'].includes(to.params.tag)) next()
        else next({ name: 'error-404' })
      },
    },

    // *===============================================---*
    // *--------- ECOMMERCE  ---------------------------------------*
    // *===============================================---*
    {
      path: '/apps/e-commerce/shop',
      name: 'apps-e-commerce-shop',
      component: () => import('@/views/apps/e-commerce/e-commerce-shop/ECommerceShop.vue'),
      meta: {
        contentRenderer: 'sidebar-left-detached',
        contentClass: 'ecommerce-application',
        pageTitle: 'Shop',
        breadcrumb: [
          {
            text: 'ECommerce',
          },
          {
            text: 'Shop',
            active: true,
          },
        ],
      },
    },
    {
      path: '/apps/e-commerce/wishlist',
      name: 'apps-e-commerce-wishlist',
      component: () => import('@/views/apps/e-commerce/e-commerce-wishlist/ECommerceWishlist.vue'),
      meta: {
        pageTitle: 'Wishlist',
        contentClass: 'ecommerce-application',
        breadcrumb: [
          {
            text: 'ECommerce',
          },
          {
            text: 'Wishlist',
            active: true,
          },
        ],
      },
    },
    {
      path: '/apps/e-commerce/checkout',
      name: 'apps-e-commerce-checkout',
      component: () => import('@/views/apps/e-commerce/e-commerce-checkout/ECommerceCheckout.vue'),
      meta: {
        pageTitle: 'Checkout',
        contentClass: 'ecommerce-application',
        breadcrumb: [
          {
            text: 'ECommerce',
          },
          {
            text: 'Checkout',
            active: true,
          },
        ],
      },
    },
    {
      path: '/apps/e-commerce/:slug',
      name: 'apps-e-commerce-product-details',
      component: () => import('@/views/apps/e-commerce/e-commerce-product-details/ECommerceProductDetails.vue'),
      meta: {
        pageTitle: 'Product Details',
        contentClass: 'ecommerce-application',
        breadcrumb: [
          {
            text: 'ECommerce',
          },
          {
            text: 'Shop',
            active: true,
          },
          {
            text: 'Product Details',
            active: true,
          },
        ],
      },
    },
    {
      path: '/campaigns/manage',
      name: 'campaigns-manage',
      component: () => import('@/views/campaigns/Campaigns.vue'),
      meta: {
        pageTitle: 'Campaigns',
        contentClass: 'all-campaigns-class',
        breadcrumb: [
          {
            text: 'Manages',
            active: true,
          },
        ],
      },
    },
    {
      path: '/fundraisers/manage',
      name: 'fundraisers-manage',
      component: () => import('@/views/fundraisers/Fundraisers.vue'),
      meta: {
        pageTitle: 'Fundraisers',
        contentClass: 'all-fundraisers-class',
        resource: 'Fundraisers',
        action: 'read',
        breadcrumb: [
          {
            text: 'Manages',
            active: true,
          },
        ],
      },
    },
    {
      path: '/charities/manage',
      name: 'charities-manage',
      component: () => import('@/views/charities/Charities.vue'),
      meta: {
        pageTitle: 'Charities and nonprofits',
        contentClass: 'all-charities-class',
        resource: 'Charities',
        action: 'read',
        charityListScope: 'managed',
        breadcrumb: [
          {
            text: 'Manage',
            active: true,
          },
        ],
      },
    },
    {
      path: '/charities/cra',
      name: 'charities-cra',
      component: () => import('@/views/charities/Charities.vue'),
      meta: {
        pageTitle: 'Charities and nonprofits',
        contentClass: 'all-charities-class',
        resource: 'Charities',
        action: 'read',
        charityListScope: 'cra',
        breadcrumb: [
          {
            text: 'CRA registered charities',
            active: true,
          },
        ],
      },
    },
    {
      path: '/charities/coupons',
      name: 'charities-coupons',
      component: () => import('@/views/charities/CharityCoupons.vue'),
      meta: {
        pageTitle: 'Charities and nonprofits',
        contentClass: 'all-charities-class',
        resource: 'Charities',
        action: 'read',
        breadcrumb: [
          {
            text: 'Coupons',
            active: true,
          },
        ],
      },
    },
    {
      path: '/surveys/responses',
      name: 'surveys-responses',
      component: () => import('@/views/surveys/Surveys.vue'),
      meta: {
        pageTitle: 'Survey Responses',
        contentClass: 'all-surveys-class',
        resource: 'Surveys',
        action: 'read',
        breadcrumb: [
          {
            text: 'Surveys',
            active: true,
          },
        ],
      },
    },
    {
      path: '/transactions',
      redirect: '/transactions/donations'
    },
    {
      path: '/transactions/donations',
      name: 'transactions-donations',
      component: () => import('@/views/Transactions/Donations.vue'),
      meta: {
        pageTitle: 'Transactions',
        contentClass: 'all-donations-transactions-class',
        resource: 'Transactions',
        action: 'read',
        breadcrumb: [
          {
            text: 'Donations',
            active: true,
          },
        ],
      },
    },
    {
      path: '/transactions/tickets',
      name: 'transactions-tickets',
      component: () => import('@/views/Transactions/Tickets.vue'),
      meta: {
        pageTitle: 'Tickets',
        contentClass: 'all-tickets-tickets-class',
        resource: 'Transactions',
        action: 'read',
        breadcrumb: [
          {
            text: 'Donations',
            active: true,
          },
        ],
      },
    },
    {
      path: '/tickets',
      redirect: '/tickets/events',
    },
    {
      path: '/tickets/events',
      name: 'tickets-events',
      component: () => import('@/views/tickets/Events.vue'),
      meta: {
        pageTitle: 'Tickets',
        contentClass: 'tickets-events-class',
        resource: 'TicketEvents',
        action: 'read',
        breadcrumb: [
          {
            text: 'Events',
            active: true,
          },
        ],
      },
    },
    {
      path: '/tickets/events/:id',
      name: 'tickets-event',
      component: () => import('@/views/tickets/Event.vue'),
      meta: {
        pageTitle: 'Ticket event',
        contentClass: 'tickets-event-class',
        resource: 'TicketEvents',
        action: 'read',
        breadcrumb: [
          {
            text: 'Events',
            to: { name: 'tickets-events' },
          },
          {
            text: 'Event',
            active: true,
          },
        ],
      },
    },
    {
      path: '/tickets/organizations',
      name: 'tickets-organizations',
      component: () => import('@/views/tickets/Organizations.vue'),
      meta: {
        pageTitle: 'Tickets',
        contentClass: 'tickets-organizations-class',
        resource: 'TicketEvents',
        action: 'read',
        breadcrumb: [
          {
            text: 'Organizations',
            active: true,
          },
        ],
      },
    },
    {
      path: '/fundraisers/categories',
      name: 'fundraisers-categories',
      component: () => import('@/views/fundraisers/Categories.vue'),
      meta: {
        pageTitle: 'Fundraisers',
        contentClass: 'all-fundraisers-class',
        breadcrumb: [
          {
            text: 'Categories',
            active: true,
          },
        ],
      },
    },
    {
      path: '/events/manage',
      name: 'events-manage',
      component: () => import('@/views/events/Events.vue'),
      meta: {
        pageTitle: 'Events',
        contentClass: 'all-events-class',
        resource: 'Events',
        action: 'read',
        breadcrumb: [
          {
            text: 'Events',
            active: true,
          },
        ],
      },
    },
    {
      path: '/fundraisers/Countries',
      name: 'fundraisers-countries',
      component: () => import('@/views/fundraisers/Countries.vue'),
      meta: {
        pageTitle: 'Fundraisers',
        contentClass: 'all-fundraisers-class',
        resource: 'Fundraisers',
        action: 'read',
        breadcrumb: [
          {
            text: 'Countries',
            active: true,
          },
        ],
      },
    },
    {
      path: '/campaigns/refunds',
      name: 'campaigns-refunds',
      component: () => import('@/views/campaigns/Refunds.vue'),
      meta: {
        pageTitle: 'Campaign Refunds',
        contentClass: 'user-management-verification-class',
        breadcrumb: [
          {
            text: 'Refunds',
            active: true,
          },
        ],
      },
    },
    {
      path: '/users/verification',
      name: 'users-verification',
      component: () => import('@/views/users/UserVerification.vue'),
      meta: {
        pageTitle: 'User Management',
        contentClass: 'user-management-verification-class',
        breadcrumb: [
          {
            text: 'Verification',
            active: true,
          },
        ],
      },
    },
    {
      path: '/users/list',
      name: 'users-list',
      component: () => import('@/views/users/UsersList.vue'),
      meta: {
        pageTitle: 'User Management',
        contentClass: 'user-management-list-class',
        resource: 'PlatformUsers',
        action: 'read',
        breadcrumb: [
          {
            text: 'Users',
            active: true,
          },
        ],
      },
    },
    {
      path: '/staff/users',
      name: 'staff-users',
      component: () => import('@/views/apps/user/user-access-control/UserAccessControl.vue'),
      meta: {
        pageTitle: 'Staff Users',
        contentClass: 'user-management-list-class',
        resource: 'StaffUsers',
        action: 'read',
        breadcrumb: [
          {
            text: 'Staff',
            active: true,
          },
        ],
      },
    },

    // *===============================================---*
    // *--------- USER MANAGER ---- ---------------------------------------*
    // *===============================================---*


     // *===============================================---*
    // *--------- FILE MANAGER ---- ---------------------------------------*
    // *===============================================---*

     // *===============================================---*
    // *--------- Cortex -------------------------------*
    // *===============================================---*



    // *===============================================---*
    // *--------- EDU stuffs -------------------------------*
    // *===============================================---*
  ]
